<template>
  <div>
    <h5
      class="font-weight-regular"
      :style="`color: white`"
      v-if="room"
    >
      {{ room.title }}
    </h5>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  props: {
    room: {
      type: Object,
      default: null
    }
  }
})
export default class Detail extends Vue {}
</script>
